import { useRef } from "react";
import { v4 } from "uuid";

import { RecaptchaAction } from "../constants/recaptcha";

import { useProtectByStrongAuth } from "./useProtectByStrongAuth";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { trpc } from "@/common/helpers/trpc";

// Wraps the sendEmailDelivery mutation with SMS 2FA protection.
// 1. Showing the SMS code modal when 2FA is required
// 2. Retrying the mutation with the verified SMS code

export const useSendEmailDeliveryWithSmsCode = () => {
  const { mutateAsync: sendEmailDeliveryMutation } = trpc.sendEmailDelivery.useMutation();
  const { mutateWithSmsCodeAndRecaptcha } = useProtectByStrongAuth("email sending");
  const { currentUser } = useCurrentUserContext();
  const intentIdRef = useRef<string | null>(null);
  const intentId = (intentIdRef.current ??= v4());

  const sendEmailDelivery = async (args: {
    emailContentId: string;
    isPreview: boolean;
    previewEmails?: string[];
    thankYouTransactionId?: string;
  }) => {
    return mutateWithSmsCodeAndRecaptcha(
      RecaptchaAction.SendEmailDelivery,
      currentUser?.email || "",
      sendEmailDeliveryMutation,
      { ...args, intentId, smsCode: null, password: null, googleSsoToken: null }
    );
  };

  return { sendEmailDelivery };
};
